import { render, staticRenderFns } from "./aboutAndJoinUs.vue?vue&type=template&id=44f83799&scoped=true&"
import script from "./aboutAndJoinUs.vue?vue&type=script&lang=js&"
export * from "./aboutAndJoinUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutAndJoinUs.vue?vue&type=style&index=0&id=44f83799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f83799",
  null
  
)

export default component.exports